import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { NavigationGuidelinesController } = await import('./index');
    return {
        Component: NavigationGuidelinesController,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
